var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"vehicle-list",attrs:{"title":"Log"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.src.employee),expression:"src.employee"}],staticClass:"tool-text",attrs:{"slot":"tools","placeholder":"Medarbejder","type":"text"},domProps:{"value":(_vm.src.employee)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.src, "employee", $event.target.value)}},slot:"tools"}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.src.order_no),expression:"src.order_no"}],staticClass:"tool-text",attrs:{"slot":"tools","placeholder":"Ordre nummer","type":"text"},domProps:{"value":(_vm.src.order_no)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.src, "order_no", $event.target.value)}},slot:"tools"}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.src.task_no),expression:"src.task_no"}],staticClass:"tool-text",attrs:{"slot":"tools","placeholder":"Opgave nummer","type":"text"},domProps:{"value":(_vm.src.task_no)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.src, "task_no", $event.target.value)}},slot:"tools"}),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.src.lead_no),expression:"src.lead_no"}],staticClass:"tool-text",attrs:{"slot":"tools","placeholder":"Henvendelsesnummer","type":"text"},domProps:{"value":(_vm.src.lead_no)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.src, "lead_no", $event.target.value)}},slot:"tools"}),_c('button-view',{attrs:{"slot":"tools","label":"Søg"},on:{"click":function($event){return _vm.update()}},slot:"tools"}),_c('new-table-view',{ref:"table",attrs:{"columns":[
		{
			label: 'Tidspunkt',
			name: 'created',
			filter: 'timestamp'
		},
		{
			label: 'Medarbejder',
			name: 'name'
		},
		{
			label: 'Emne',
			name: 'object'
		},
		{
			label: 'Handling',
			name: 'action'
		},
		{
			label: 'Tilbud',
			name: 'quote_num'
		},
		{
			label: 'Ordre',
			name: 'order_num'
		},
		{
			label: 'Opgave',
			name: 'task_num'
		},
		{
			label: 'Henvendelse',
			name: 'lead_num'
		}
	],"items":_vm.items,"actions":_vm.actions},on:{"itemClick":_vm.itemClick,"delete":_vm.itemDelete,"action":_vm.action}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }